// Configuration pour désactiver les logs console en production
// Ce fichier sera importé dans l'App pour nettoyer la console

export const disableConsoleLogs = () => {
  if (process.env.NODE_ENV === 'production') {
    // Désactiver tous les logs sauf les erreurs critiques
    const noop = () => {};
    
    console.log = noop;
    console.debug = noop;
    console.info = noop;
    console.warn = noop;
    
    // Garder console.error pour les vrais problèmes
    // mais les rendre silencieux si nécessaire
    // console.error = noop;
  }
};

// Appeler automatiquement au chargement
if (typeof window !== 'undefined' && process.env.NODE_ENV === 'production') {
  disableConsoleLogs();
}

export default disableConsoleLogs;
